// extracted by mini-css-extract-plugin
export default {"paper":"rymb6AZDR8ywXq2NcDV6","addNewPersonIcon":"K0CUCpPLQGf0nVC_RBAV","infoBox":"MmJxcHTRxSa_d7RNHaWW"};